export const UNREPLIED_THRESHOLD_MS = 10 * 60 * 1000;

export const isTicketUnreplied = (ticket, now = Date.now()) => {
  if (!ticket || ticket.status !== "open") return false;
  if (!ticket.lastClientMessageAt) return false;
  const lastClient = new Date(ticket.lastClientMessageAt).getTime();
  if (Number.isNaN(lastClient)) return false;
  if (now - lastClient <= UNREPLIED_THRESHOLD_MS) return false;
  const lastAgent = ticket.lastAgentMessageAt
    ? new Date(ticket.lastAgentMessageAt).getTime()
    : 0;
  return lastAgent < lastClient;
};
